var _defs, _circle, _circle2, _text, _circle3, _circle4, _text2, _circle5, _circle6, _text3, _circle7, _circle8, _text4, _circle9, _circle0, _text5, _circle1, _circle10, _text6, _polygon, _polygon2, _rect, _text7, _rect2, _line, _line2, _line3, _polyline, _line4, _polyline2, _line5, _path, _polygon3, _circle11, _circle12, _circle13, _line6, _polygon4, _polygon5, _rect3, _path2, _path3, _path4, _path5, _line7, _line8, _line9, _polyline3, _line0, _polyline4, _line1, _path6, _polygon6, _circle14, _circle15, _circle16, _line10, _polygon7, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path7, _path8, _path9, _rect12, _path0, _path1, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _text8, _line11, _line12, _line13, _line14, _line15, _line16, _polygon8, _circle17, _circle18, _text9, _circle19, _circle20, _text0, _path10, _polyline5, _polygon9, _path11, _path12, _path13, _polygon0, _polygon1, _path14, _g, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g2, _path29, _ellipse, _path30, _ellipse2, _line17, _path31, _path32, _path33, _polygon10, _polygon11, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickjacking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 781,
    height: 440,
    viewBox: "0 0 781 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.86,298.78s-10.37-65.77-10.68-76,3.36-21.8,4-27.08-2.37-53.79-1.46-53.79,8.17-16.18,9.08-16.18,27.83,3.63,35.4,2.64,28.14-2,28.14-2,3.33,23.45,2.12,37-2.66,40.58-3.26,52.47-5,42.27-5,42.27l-9,38.69Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.41,153.87c.45,0,7.09-.52,15.57-.52,5,0,5.32-1.73,5.47-6.54s-.75-23.74-8-30.51-23.89-9-23.29-8.11-3.76,9.32.3,17,8.87,18.79,8.87,19.39S732.41,153.87,732.41,153.87Z",
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clickjacking infographic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 146.86,
    cy: 201.67,
    r: 24.34,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.86,
    cy: 201.67,
    r: 18,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(138.33 208.59) rotate(15.65)",
    fontSize: 24.42,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.28,
    cy: 317.99,
    r: 21.06,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.28,
    cy: 317.99,
    r: 15.57,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.99, 0.12, -0.12, 0.99, 191.84, 325.05)",
    fontSize: 21.13,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.82,
    cy: 219.18,
    r: 14.62,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.82,
    cy: 219.18,
    r: 10.81,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(360.86 225.72) rotate(-27.36)",
    fontSize: 14.67,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.31,
    cy: 253.36,
    r: 14.62,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.31,
    cy: 253.36,
    r: 10.81,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.86, 0.51, -0.51, 0.86, 246.25, 256.06)",
    fontSize: 14.67,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.39,
    cy: 203.54,
    r: 12.94,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.39,
    cy: 203.54,
    r: 9.57,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(223.87 209.42) rotate(-40.6)",
    fontSize: 12.98,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.44,
    cy: 161.71,
    r: 20.58,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.44,
    cy: 161.71,
    r: 15.22,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(381.1 170.91) rotate(-27.36)",
    fontSize: 20.64,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "420.82 123.93 420.82 93.11 138.71 93.11 133.33 76.66 42.91 76.66 42.91 123.93 420.82 123.93",
    fill: "#d4f1d3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "420.72 346.67 42.81 346.67 42.81 76.35 133.23 76.35 138.61 92.81 420.72 92.81 420.72 346.67",
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.32,
    y: 200.21,
    width: 154.29,
    height: 52.2,
    rx: 3.53,
    fill: "#70d16d"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(201.94 234.35)",
    fontSize: 26.54,
    fill: "#fff",
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, "Pay")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.03,
    y: 98.03,
    width: 319.8,
    height: 21.25,
    rx: 2.21,
    fill: "#fff",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 54.23,
    y1: 86.31,
    x2: 108.05,
    y2: 86.31,
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 122.29,
    y1: 83.11,
    x2: 128.96,
    y2: 89.78,
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 128.96,
    y1: 83.11,
    x2: 122.29,
    y2: 89.78,
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "55 104.86 49.5 110.37 54.66 115.53",
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 57.52,
    y1: 110.19,
    x2: 49.5,
    y2: 110.19,
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "64.1 114.87 68.78 110.19 64.39 105.8",
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 60.41,
    y1: 110.34,
    x2: 68.78,
    y2: 110.34,
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.94,111.84a4.53,4.53,0,1,1-2.8-5.76,4.62,4.62,0,0,1,1.7,1",
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.66 107.99 83.94 104.41 83.94 108.92 79.66 107.99",
    fill: "#70d16d"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.52,
    cy: 103.07,
    r: 1.34,
    fill: "#70d16d"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.52,
    cy: 107.69,
    r: 1.34,
    fill: "#70d16d"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.52,
    cy: 112.32,
    r: 1.34,
    fill: "#70d16d"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 42.81,
    y1: 123.62,
    x2: 420.72,
    y2: 123.62,
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "537.77 382.16 159.86 382.16 159.86 111.84 250.28 111.84 255.66 128.3 537.77 128.3 537.77 382.16",
    fill: "#fff",
    opacity: 0.5
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "537.77 159.11 537.77 128.3 255.66 128.3 250.28 111.84 159.86 111.84 159.86 159.11 537.77 159.11",
    fill: "#edd6d6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 208.18,
    y: 133.6,
    width: 319.8,
    height: 21.25,
    rx: 2.21,
    fill: "#fff",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.87,114.82,272,125.26H259.27l-3.16-10.44Z",
    fill: "#edd6d6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.87,114.82,272,125.26H259.27l-3.16-10.44Z",
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.93,79.4l3.17,10.44H141.34L138.18,79.4Z",
    fill: "#d4f1d3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.93,79.4l3.17,10.44H141.34L138.18,79.4Z",
    fill: "none",
    stroke: "#70d16d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 169.66,
    y1: 121.89,
    x2: 226.21,
    y2: 121.89,
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 240.44,
    y1: 118.68,
    x2: 247.11,
    y2: 125.35,
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 247.11,
    y1: 118.68,
    x2: 240.44,
    y2: 125.35,
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "172.13 141.42 167.65 145.91 171.85 150.11",
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 175.67,
    y1: 145.76,
    x2: 167.65,
    y2: 145.76,
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "182.25 150.44 186.93 145.76 182.54 141.37",
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 178.56,
    y1: 145.91,
    x2: 186.93,
    y2: 145.91,
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.09,147.41a4.52,4.52,0,1,1-1.1-4.71",
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.81 143.56 202.09 139.98 202.09 144.49 197.81 143.56",
    fill: "#d60000"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.67,
    cy: 138.64,
    r: 1.34,
    fill: "#d60000"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.67,
    cy: 143.26,
    r: 1.34,
    fill: "#d60000"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.67,
    cy: 147.89,
    r: 1.34,
    fill: "#d60000"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 160.96,
    y1: 159.19,
    x2: 538.87,
    y2: 159.19,
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "538.87 382.24 160.96 382.24 160.96 111.92 251.38 111.92 256.76 128.38 538.87 128.38 538.87 382.24",
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 272.26,
    y: 235.78,
    width: 154.29,
    height: 52.2,
    rx: 3.53,
    fill: "#d60000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 272.26,
    y: 235.78,
    width: 154.29,
    height: 52.2,
    rx: 3.53,
    fill: "#d60000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 335.85,
    y: 294.73,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 290.4,
    y: 218.49,
    width: 0.97,
    height: 5.79,
    transform: "translate(-46.05 79.62) rotate(-14.46)",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 311.69,
    y: 218.31,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 316.97,
    y: 299.5,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 331.53,
    y: 223.25,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 293.27,
    y: 302.92,
    width: 5.79,
    height: 0.97,
    transform: "translate(-47.31 552) rotate(-81.59)",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 256.83,
    y: 264.01,
    width: 5.79,
    height: 0.97,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 240.79,
    width: 0.97,
    height: 5.79,
    transform: "matrix(0.13, -0.99, 0.99, 0.13, -16.39, 468.63)",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.4,300.59l-2.59,5.18q.53.25,1.08.48l.05,0,2.14-5.37C273.85,300.81,273.62,300.7,273.4,300.59Z",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259.13,289l.31.52c.07.13.15.26.23.38l4.91-3.06-.45-.76Z",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268,221.91l3.13,4.87c.21-.14.42-.26.64-.38L269,221.31C268.65,221.5,268.32,221.7,268,221.91Z",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 418.11,
    y: 296.57,
    width: 0.97,
    height: 5.79,
    transform: "translate(-41.56 68.9) rotate(-8.97)",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M439.16,293.91l5.14,2.65c.18-.35.35-.71.5-1.07l-5.32-2.26C439.38,293.46,439.27,293.69,439.16,293.91Z",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M437.8,224.43l-4,4.16a6.63,6.63,0,0,1,.52.54l4.32-3.85C438.35,225,438.08,224.7,437.8,224.43Z",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 351.86,
    y: 223.25,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 433.3,
    y: 269.4,
    width: 5.79,
    height: 0.97,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 436.19,
    y: 248.59,
    width: 5.79,
    height: 0.97,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 410.91,
    y: 223.59,
    width: 5.79,
    height: 0.97,
    transform: "translate(19.91 481.55) rotate(-61.61)",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 372.18,
    y: 223.25,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 397.98,
    y: 302.4,
    width: 0.97,
    height: 5.79,
    transform: "translate(-17.26 23.96) rotate(-3.37)",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 294.73,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 376.98,
    y: 297.62,
    width: 0.97,
    height: 5.79,
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 390.1,
    y: 223.83,
    width: 5.79,
    height: 0.97,
    transform: "translate(90.91 561.22) rotate(-77.84)",
    fill: "#d60000",
    stroke: "#d60000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 272.26,
    y: 235.78,
    width: 154.29,
    height: 52.2,
    rx: 3.53,
    fill: "#d60000"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(325.97 271.34)",
    fontSize: 26.54,
    fill: "#fff",
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-0.01em"
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.82,
    y: 0
  }, "in"))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 424.97,
    y1: 94.01,
    x2: 426.84,
    y2: 94.51,
    fill: "none",
    stroke: "#cbd0d1",
    strokeMiterlimit: 10
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 429.68,
    y1: 95.27,
    x2: 534.49,
    y2: 123.4,
    fill: "none",
    stroke: "#cbd0d1",
    strokeMiterlimit: 10,
    strokeDasharray: "3.93 2.95"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 535.91,
    y1: 123.79,
    x2: 537.77,
    y2: 124.29,
    fill: "none",
    stroke: "#cbd0d1",
    strokeMiterlimit: 10
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 45.28,
    y1: 350.27,
    x2: 47.14,
    y2: 350.78,
    fill: "none",
    stroke: "#cbd0d1",
    strokeMiterlimit: 10
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 49.93,
    y1: 351.54,
    x2: 152.72,
    y2: 379.69,
    fill: "none",
    stroke: "#cbd0d1",
    strokeMiterlimit: 10,
    strokeDasharray: "3.86 2.89"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 154.11,
    y1: 380.07,
    x2: 155.97,
    y2: 380.58,
    fill: "none",
    stroke: "#cbd0d1",
    strokeMiterlimit: 10
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.72 270.44 398.75 266.04 405.05 264.24 386.3 252.33 392.57 273.64 395.68 268.63 398.89 274.07 403.72 270.44",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.96
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.09,
    cy: 287.82,
    r: 17.41,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.09,
    cy: 287.82,
    r: 12.88,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(102.46 295.68) rotate(-38.28)",
    fontSize: 17.47,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.86,
    cy: 156.88,
    r: 15.2,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.86,
    cy: 156.88,
    r: 11.24,
    fill: "#fff3db",
    stroke: "#ffaf10",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.91, 0.41, -0.41, 0.91, 75.94, 160.37)",
    fontSize: 15.24,
    fill: "#ffaf10",
    fontFamily: "ArialMT, Arial"
  }, "$")), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M424.61,236.18v49.37H272.45a3.51,3.51,0,0,0,3.34,2.43H423a3.53,3.53,0,0,0,3.53-3.53V239.31A3.49,3.49,0,0,0,424.61,236.18Z",
    opacity: 0.3
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "549.23 298.92 619.86 298.92 619.86 265.31 593.79 265.31 593.79 211.29 641.36 211.29 641.36 237.9 614.91 237.9 614.91 168.73",
    fill: "none",
    stroke: "#d60000",
    strokeMiterlimit: 10
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "558.02 304.92 549.23 298.88 558.26 292.92 558.02 304.92",
    fill: "#d60000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M698.51,274.9c.46-3.75,18.26-32.78,14.51-32.78s-26.22,5.62-26.22,5.62-10.31-6.56-8.43,1.87-2.34.47,2.34,8,2.81,8,5.15,14.05,4.68,11.71,4.68,11.71Z",
    fill: "#4c5054"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M700.54,377.55s2.05,10.68,2.78,17.4,2,19.05,1.68,20.57-.11,4.67-8.76,4.2-14.21-1.51-12.49-10.4,4.82-14.84,4.27-18.7-1.19-8.08-1-9.64Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M668.53,376.12s-3.85,7-3.67,10.85,5.77,16.09,12.07,20.82,5.42,8.92,3.67,10-11.54,3.32-20.46-1.22-3.33-11.73-12.78-17-5.94-12-3.5-14.39,6.09-5.68,6.65-9.05,1.91-7.27,3.17-7.3S668.53,376.12,668.53,376.12Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "684.98 385.07 669.23 296.87 660.47 238.63 681.83 242.37 691.28 293.35 703.6 382.26 684.98 385.07",
    fill: "#4c5054"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "667.38 381.76 649.17 373.54 685.72 301.63 706.91 221.92 728.5 227.66 706.61 309.99 667.38 381.76",
    fill: "#4c5054"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M728.06,105.85s10,3,13.11,4.57,7.53,7.16,9.57,18.84,2.52,24.61,1.73,24.61-4.8-.43-5.92-.52a60.73,60.73,0,0,0-9.89-.33c-5.91.23-6.29,1-6.59,2s-2.56,35.4-.57,49.6c3.79,27.16-13.2,91.32-14.92,92.52s-8.18,5.73-26.2,4.89c-16.21-.75-21.64-4-22.07-4.51-1.32-1.45-10.46-46-11.13-85.31-.13-8.29,4.22-12.53,5.15-20.57,1.18-10.11-1-25-2.11-27.75-1.87-4.76-7.5-19.08-6.66-23.39s6.22-20.88,9.44-24.82,3.57-8,20.16-6.08S728.06,105.85,728.06,105.85Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M659.7,281.75a117.71,117.71,0,0,0,29.42,4.34,231.56,231.56,0,0,0,31.55-1.88",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.88,261.41a117,117,0,0,0,32.19,5.29,227.67,227.67,0,0,0,34.51-2.3",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.23,237.63S672,244.8,691,245.2a232.21,232.21,0,0,0,36.53-2.52",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.06,217.51a120.26,120.26,0,0,0,37,6.88,231.91,231.91,0,0,0,39.66-3",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.06,196.37a120.43,120.43,0,0,0,37,6.89,231.33,231.33,0,0,0,39.66-3",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.15,174.08a120.26,120.26,0,0,0,37,6.88,232.08,232.08,0,0,0,39.67-3",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.15,174.08a120.26,120.26,0,0,0,37,6.88,232.08,232.08,0,0,0,39.67-3",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.66,153.08a120.46,120.46,0,0,0,37,6.89,231.46,231.46,0,0,0,39.66-3",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.87,128.5a95.06,95.06,0,0,0,36.92,8.78c20,.46,39.34-6.61,39.34-6.61",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M692.93,123.41c-6.14.17-24.38-4.49-20.43-11.59s10.12-6,10.2-15.18,24.81-7.08,24.81-7.08-3,11.82,2.12,13.76,24.29,4,16.39,10S707.94,123,692.93,123.41Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M750,153.08s-1.56,14.18-4,25.11c-1.71,7.78-7.41,25.47-9.81,25.67-3.57.29-23.81-12.34-37.32-27.45-5.07-5.66-7.73-7.55-8.42-7.76s-15.67-15.4-15.67-15.4l2.06-3.68a2.59,2.59,0,0,1,1.51-.46c.92,0,2.49-.6,3-.6a5.1,5.1,0,0,1,2.21.07c1,.33,2.7,2.22,3.11,2.58,1.51,1.33,10.23,7.44,12.28,9,1.76,1.33,14.55,10.56,17,11.85s12.4,7.43,12.72,6.38.85-20.48,1.49-24.64C730.46,151.79,744.31,152.58,750,153.08Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M679,18.12c4.35-.25,18.54-5.14,30.1,3.74,22.59,17.36,21,29,21.72,36.34s5.54,15.86,8.84,21.67c10.39,18.24,5.63,30,1.52,41s5.33,11.9,4.76,21.84c-.26,4.56-4.74,24.73-27.08,15.23-21-8.92,6.42-32.14-11.71-44.23-8.93-6-2-11.73-3.87-17.86-4.77-15.9-23.09,7-23.09,7s1.16,11.68-4.15,17.48c-5.15,5.64-1.82,11.55-2.14,19.27-.35,8.66-8.47,19.28-18,13.78-8.49-4.86,2.58-11.71,4.42-18.73,2.69-10.26-9-21.92-9.71-27.67-1-9,9.16-9.35,7.05-19.62-1-5-12.25-15.45-11.18-25.72C647.08,55.43,656.35,19.38,679,18.12Z",
    fill: "#4c5054",
    stroke: "#4c5054",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M670.69,35.47c6.69-4.08,29.8,1.16,36.46,14.46s4.21,34.39-3.15,42.7-19.46,12.63-24.37,9.63-16.48-26.08-17.18-30.9,1.22-10.14,0-12.3S657.89,43.28,670.69,35.47Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M609.1,146.58l63.24-.84a.8.8,0,0,1,.53.19l29.41,24.15a.83.83,0,0,1-.55,1.47l-65.94-2.09a.74.74,0,0,1-.49-.18l-26.7-21.22A.83.83,0,0,1,609.1,146.58Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M607.32,146.56l60.71.52a3.48,3.48,0,0,0,3.49-3.78L658.53,85a3.47,3.47,0,0,0-3.84-3.15l-61.93,6.85a3.49,3.49,0,0,0-3.07,3.88L603.9,143.5A3.47,3.47,0,0,0,607.32,146.56Z",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M677,407.6s-9.12,2.78-11.89,5.75a24.56,24.56,0,0,0-3.17,3.76",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M671.25,401.46s-5.94-.4-9.9,2S654,408.2,654,408.2",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M666.3,392.54a34.23,34.23,0,0,0-12.34,0c-5.75,1.28-7.93,4.95-7.93,4.95",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M649.46,379.47a69.73,69.73,0,0,0,9.71,3.76,28.89,28.89,0,0,0,5.35,1.19",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M687.89,389s3,0,7.14-.39,6.54-.8,6.54-.8",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M686.72,398.71a54.12,54.12,0,0,1,8.51-.66,46.15,46.15,0,0,1,8.58.74",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M683.54,409.61a119.66,119.66,0,0,1,12.26-.95,31,31,0,0,1,8.94,1.35",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M643.35,159.27a5.4,5.4,0,0,0-.79,2.81,14.33,14.33,0,0,0-.25,4,6.9,6.9,0,0,1-.07,3.92c-.5,1.72-2.56,10.93-.06,15.05s5.26,7.72,7.58,7.4a10.7,10.7,0,0,0,7.17-5c1.94-3.57,2.67-6.28,2.05-7.95-.5-1.34-2.92-2.23-3.45-2.75a4.35,4.35,0,0,1-.07-.81c.21-.64-.4-3.74,0-4.27.49-.68,4.28-2.68,5.59-3.6s2.58-1.74,3.6-2.37l3-2a1.49,1.49,0,0,0,.08-1.81c-.19-.37-.83-.51-1.18-.7-.7-1-12.62,5.64-12.62,5.64s13-8.15,12.89-9.19a1.79,1.79,0,0,0-.19-1.66c-.17-1.78-16.16,6.05-16.16,6.05s13.65-7.09,12.11-8.55c-1.22-1.17-8.47,1.49-12.33,3.07-2.55.9-6.35,2-6.91,2.7",
    fill: "#fff",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.31,126.22a27.7,27.7,0,0,1,11.27-3.15c6.31-.3,7.36.6,7.36.6",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.7,141.1s17.28-4.21,24.2-2.25",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M699.11,53.88S697,69,691.7,70.46c-3.59,1.16-11.42-.08-14,0-2,.11-7.61,6.72-9.7,6.72-4.65,0-14.07-8.56-14.07-8.56l-.68-2.7c4.09-4,17.06-6.34,23.29-1.79,5.67-7.8,17.43-13.18,22.05-12.19Z",
    fill: "#4c5054",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 1.84
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.32,
    cy: 68.55,
    rx: 5.05,
    ry: 2.53,
    transform: "translate(-2.9 97.18) rotate(-8.31)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M712.47,46.61s-14.49,7.65-16.2,8.77",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 686.69,
    cy: 64.37,
    rx: 5.06,
    ry: 2.53,
    transform: "translate(13.86 215.98) rotate(-18.05)",
    fill: "#fff"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 678.39,
    y1: 89.08,
    x2: 689.26,
    y2: 87.32,
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M711.43,112.1a20.21,20.21,0,0,1-10.67-23.42c1.66-6.26,3.88-12.8,6.48-16.06,5.85-7.31,12.68,5.86,13.16,10.73s-1.46,27.3-2.92,28.28-2,2-4.88,1A11.32,11.32,0,0,1,711.43,112.1Z",
    fill: "#4c5054",
    stroke: "#4c5054",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M642.61,159.8s5.92-5.55,7.75-6.25c2.28-.86,6.78-1.36,7.48.4",
    fill: "none",
    stroke: "#4c5054",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M674.14,43.65c4.7,12.73,12.52,5.73,16.94,16.59s14,16.8,28,11.88c2.37-.84-7.66-31.63-7.66-31.63L685.74,24.6,672.89,35.28S672.27,38.6,674.14,43.65Z",
    fill: "#4c5054",
    stroke: "#4c5054",
    strokeMiterlimit: 10
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "100 371.86 94.47 363.2 104.72 361.3 100 371.86",
    fill: "#cbd0d1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "480.23 116.27 474.7 107.61 484.95 105.7 480.23 116.27",
    fill: "#cbd0d1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M637.36,116.57c0-2.07-2-4.13-2.73-4.25a10.28,10.28,0,0,0-2.39.18s-1.07.17-2,.4-1,1.07-.3,3.48,3.13,4.11,5.14,3.89S637.38,118.63,637.36,116.57Z",
    fill: "#d60000"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M629.24,118.8s-1.21.3-1.17,3,.09,3.57.32,3.63.59-.9.88-1.39.33-.79.69-.79,1.3,1.42,1.57,1.72.19.32.42.27-.4-2.78-1-4.21S629.73,118.8,629.24,118.8Z",
    fill: "#d60000"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M649.92,128.43c-1.3-1.05-4.09-.74-6.14-1.21-1.89-.43-6.41-2.15-7.09-2.41a1.64,1.64,0,0,1,.36-.58,9.71,9.71,0,0,0,2.07-2.64l2.36-1a23.12,23.12,0,0,1,5.59-1.63,2.18,2.18,0,0,0,1.93-2.36,2.25,2.25,0,0,0-1-1.76s0-.32-.14-.86a2.25,2.25,0,0,0-.86-1.42,1.72,1.72,0,0,0-2.37.06,14.68,14.68,0,0,1-2.45,2.53c-.53.38-1.94,1.15-2.72,1.57a17.77,17.77,0,0,1-.13-3.37,56.86,56.86,0,0,0,.37-6.59c-.08-2.48-.39-4.87-3.69-7s-6.43-3.5-10.81-3.24l-.33,0c-1.87,0-4.83.37-6.56,2-2.66,2.59-3,4.63-2.47,7.33s1.91,7.15,2.21,8.52c.18.83.27,1.54.35,2.15-.9-.47-2.47-1.31-3.09-1.72a15.11,15.11,0,0,1-2.55-2.39,1.7,1.7,0,0,0-2.41-.19,1.77,1.77,0,0,0-.49,1.49,8.77,8.77,0,0,0,.09.93,1.81,1.81,0,0,0-.55,1.87,3.29,3.29,0,0,0,2.58,2.6,20.06,20.06,0,0,1,5.46,1.44l2.72,1.11a8.47,8.47,0,0,0,2.66,2.64,5.15,5.15,0,0,1,1.19,1,47.76,47.76,0,0,1-6.36,2.83c-1.92.51-4.41.17-5.43,1.31a2.62,2.62,0,0,0-.36,3.11,2.45,2.45,0,0,0,1.19,1.53l.32.15a3,3,0,0,0,1.12,2.44c1.19.81,2.16,1,3.27-1.07a12.94,12.94,0,0,1,5-4.88c1.72-1,3-1.72,3.34-1.94a6.53,6.53,0,0,0,4.19,1.8h.5c1,0,3.4-.18,4.42-1.87.12-.2.22-.39.32-.58.45.21,1.84.87,3.82,1.83a18.55,18.55,0,0,1,6.2,4.52c1.62,1.9,2.85,1.79,3.82,1s.21-2.35.21-2.35,0-.07.27-.21A1.81,1.81,0,0,0,651,131.6,3,3,0,0,0,649.92,128.43Zm-10.35-11s2.52-1.32,3.11-1.74a8.24,8.24,0,0,0,2-2.17,1.35,1.35,0,0,1,2-.24,2.65,2.65,0,0,1,.6,1.46,3.54,3.54,0,0,1-.4,1.31,2.05,2.05,0,0,0,.5-.82,1.38,1.38,0,0,1,.82,1.42c0,.72-.23,1.2-2.39,1.56a21.12,21.12,0,0,0-5.17,1.79l-1.23.53,0-.34a5.32,5.32,0,0,0,.12-1.19,5.9,5.9,0,0,0,0-.73ZM618.05,120a29.41,29.41,0,0,0-5.65-1.78c-2.28-.45-2.19-.82-2.43-1.6-.34-1.08.44-1.55.48-1.47a3.26,3.26,0,0,0,.72.91,5.39,5.39,0,0,1-.75-1.43,2.34,2.34,0,0,1,.21-1.54c.18-.43.9-1,1.67-.09a12.91,12.91,0,0,0,2.63,2.41c.66.43,3.23,1.75,3.55,1.91,0,.11,0,.23,0,.34s.07.33.13.53v0a16.41,16.41,0,0,0,.77,2.36Zm2.23,11.28a10.79,10.79,0,0,0-3.27,3.76c-.6.94-1.62,1.84-2.79.63s-.13-3.19-.16-3.16a3.72,3.72,0,0,0-.56,1,2.45,2.45,0,0,1-.9-.62,2.56,2.56,0,0,1-.33-2.58c.38-.89,2-1,4.89-1.53s7-3.17,7-3.17.25.5.48.94.85,1.47.85,1.47S622.28,129.91,620.28,131.32Zm14.15-5.16-.06.1c-.11,0-.2,0-.15.23A1.63,1.63,0,0,1,634,128c-.41.39-.64-.73-.64-.73l-.07,0s.28,1.14-.12,1.28-.51-1-.51-1h-.13s.45,1.33-.16,1.53-.62-1.35-.62-1.35h-.27s.56,1.63-.32,1.68-.79-1.57-.79-1.57h-.35s.56,1.62-.37,1.65-.77-1.69-.77-1.69h-.35s.35,1.43-.22,1.46-.61-1.63-.61-1.63h-.12s0,.36,0,.72-.28.51-.47.26a4.06,4.06,0,0,1-.25-1.22h-.07a1.37,1.37,0,0,0,0,.3c0,.33,0,.63-.39.58s-.52-1.25-.59-1.68v-.16s-.77-1.22-1.21-2.07-1.07-.83-2.24-1.44-2.68-1.37-3.36-5.69v-.14l0-.2h0c-.06-.43-.11-.88-.15-1.38-.14-1.68.88-3.67.59-6.95s-1-3.74-1.08-3.52,0,4.11-.09,5.72a13.34,13.34,0,0,1-.25,2.44s-2.41-7.44-1.47-9.65,2.2-4.06,4.12-4.94a22.06,22.06,0,0,1,5.13-1.19,15.4,15.4,0,0,1,5.49,1.18c3.08,1.28,6.73,4.87,7.09,7a19,19,0,0,1,.15,5.35c-.15,2.28-.19,3-.19,3s-2.29-6.71-2.58-7.61-.79-1-.8,0a13.47,13.47,0,0,0,1.49,5.66c1.25,2.55,2.42,4.7,2.19,7.17s-1.83,3.45-2.91,4.36A5.17,5.17,0,0,0,634.43,126.16ZM650,131.83a1.68,1.68,0,0,1-.74.61,5,5,0,0,0-.8-.91s1.49,1.79.63,3-2.09.37-2.92-.49a15.21,15.21,0,0,0-4.2-3.49c-2.3-1.28-5.87-3-6-3.08a15.8,15.8,0,0,0,.58-1.87,45,45,0,0,0,7.94,2.5c3,.44,4.65.55,5.25,1.38A2.2,2.2,0,0,1,650,131.83Z",
    fill: "#d60000"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M626.49,112.81c-1-.27-2.07-.5-2.07-.5A11.38,11.38,0,0,0,622,112c-.74.09-2.15,2.14-1.63,4.28s1.13,3.61,3.21,3.88a3.8,3.8,0,0,0,4.15-3.82C627.76,113.94,627.44,113.08,626.49,112.81Z",
    fill: "#d60000"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M639.13,118.51c0-2.06-2-4.13-2.72-4.25a10.15,10.15,0,0,0-2.4.19s-1.06.17-2,.39-1,1.08-.3,3.48,3.12,4.12,5.14,3.89S639.15,120.57,639.13,118.51Z",
    fill: "#60bcd8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M631,120.75s-1.21.29-1.17,3,.09,3.58.32,3.63.59-.89.88-1.38.33-.8.68-.8,1.3,1.43,1.58,1.72.19.32.42.28-.41-2.78-1-4.21S631.51,120.75,631,120.75Z",
    fill: "#60bcd8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M651.7,130.37c-1.3-1.05-4.09-.74-6.14-1.2-1.89-.43-6.41-2.15-7.09-2.42a1.4,1.4,0,0,1,.36-.57,10.28,10.28,0,0,0,2.07-2.64l2.36-1a22.55,22.55,0,0,1,5.59-1.62,2.18,2.18,0,0,0,1.93-2.36,2.25,2.25,0,0,0-1-1.76s0-.33-.14-.87a2.22,2.22,0,0,0-.87-1.41,1.72,1.72,0,0,0-2.36,0A14.33,14.33,0,0,1,644,117.1c-.53.39-2,1.16-2.72,1.58a17,17,0,0,1-.13-3.37,57,57,0,0,0,.37-6.6c-.08-2.47-.39-4.87-3.69-7s-6.44-3.49-10.81-3.23l-.33,0c-1.87,0-4.83.37-6.56,2-2.66,2.59-3,4.63-2.47,7.32s1.91,7.16,2.21,8.53c.18.83.27,1.53.35,2.15-.9-.47-2.47-1.31-3.1-1.73a15.47,15.47,0,0,1-2.55-2.39,1.7,1.7,0,0,0-2.4-.18,1.72,1.72,0,0,0-.49,1.49,8.77,8.77,0,0,0,.09.93,1.78,1.78,0,0,0-.55,1.86,3.29,3.29,0,0,0,2.58,2.61,19.58,19.58,0,0,1,5.46,1.43l2.72,1.12a8.57,8.57,0,0,0,2.66,2.64,4.69,4.69,0,0,1,1.19,1,47.76,47.76,0,0,1-6.36,2.83c-1.92.51-4.41.17-5.43,1.31a2.59,2.59,0,0,0-.36,3.1,2.48,2.48,0,0,0,1.19,1.54l.32.14a3,3,0,0,0,1.12,2.45c1.19.81,2.16,1,3.27-1.08a13.12,13.12,0,0,1,5-4.88c1.73-1,3-1.71,3.35-1.93a6.53,6.53,0,0,0,4.19,1.8h.5c1,0,3.4-.19,4.42-1.87a5.58,5.58,0,0,0,.31-.59c.45.22,1.85.87,3.83,1.84a18.4,18.4,0,0,1,6.19,4.52c1.63,1.9,2.86,1.79,3.83,1s.21-2.35.21-2.35,0-.06.27-.2a1.83,1.83,0,0,0,1.16-1.42A3.05,3.05,0,0,0,651.7,130.37Zm-10.35-11s2.51-1.33,3.11-1.74a8.24,8.24,0,0,0,2-2.17,1.34,1.34,0,0,1,2-.24,2.69,2.69,0,0,1,.6,1.45,3.68,3.68,0,0,1-.4,1.32,2,2,0,0,0,.49-.83,1.39,1.39,0,0,1,.82,1.43c0,.72-.22,1.19-2.39,1.55a21.57,21.57,0,0,0-5.16,1.8l-1.23.53,0-.34a5.32,5.32,0,0,0,.12-1.19,5.9,5.9,0,0,0,0-.73C641.36,119.47,641.35,119.38,641.35,119.38ZM619.82,122a29.29,29.29,0,0,0-5.64-1.78c-2.28-.45-2.19-.83-2.43-1.6-.34-1.08.44-1.55.48-1.47a3.36,3.36,0,0,0,.71.91,5.8,5.8,0,0,1-.74-1.43,2.28,2.28,0,0,1,.21-1.54c.18-.43.9-1,1.67-.09a13.07,13.07,0,0,0,2.62,2.4c.67.43,3.24,1.76,3.56,1.92,0,.11,0,.23,0,.33s.07.33.13.53v0a16.88,16.88,0,0,0,.77,2.36Zm2.23,11.27a10.94,10.94,0,0,0-3.26,3.77c-.61.94-1.62,1.84-2.79.63s-.13-3.19-.16-3.17a3.91,3.91,0,0,0-.56,1,2.45,2.45,0,0,1-.9-.62,2.54,2.54,0,0,1-.33-2.58c.38-.89,2-1,4.88-1.54s7-3.16,7-3.16.25.5.48.94.85,1.47.85,1.47S624.06,131.85,622.05,133.26Zm14.16-5.15-.06.1c-.11,0-.21,0-.15.23a1.58,1.58,0,0,1-.19,1.54c-.4.4-.63-.72-.63-.72l-.07,0s.28,1.13-.12,1.28-.51-1-.51-1h-.14s.46,1.33-.15,1.53-.62-1.35-.62-1.35h-.27s.56,1.64-.32,1.69-.79-1.58-.79-1.58h-.35s.56,1.61-.37,1.65-.78-1.69-.78-1.69h-.34s.35,1.44-.22,1.46-.61-1.62-.61-1.62h-.13s0,.37,0,.73-.28.51-.47.26a3.77,3.77,0,0,1-.25-1.22h-.07a1.38,1.38,0,0,0,0,.3c0,.33,0,.63-.39.58s-.52-1.25-.59-1.68v-.16s-.77-1.22-1.21-2.08-1.07-.82-2.25-1.44-2.67-1.36-3.35-5.69a.79.79,0,0,0,0-.14l0-.19h0c-.06-.43-.12-.89-.16-1.39-.13-1.67.89-3.66.6-6.94s-1-3.74-1.08-3.53,0,4.12-.09,5.73a13.34,13.34,0,0,1-.25,2.44s-2.41-7.45-1.47-9.66,2.19-4.06,4.11-4.93a22.25,22.25,0,0,1,5.14-1.19,15.32,15.32,0,0,1,5.49,1.17c3.08,1.29,6.73,4.88,7.09,7a19.08,19.08,0,0,1,.15,5.36c-.15,2.28-.19,3-.19,3s-2.3-6.72-2.58-7.61-.79-1-.8,0a13.25,13.25,0,0,0,1.49,5.66c1.25,2.56,2.42,4.71,2.19,7.18s-1.83,3.44-2.91,4.35A5.23,5.23,0,0,0,636.21,128.11Zm15.52,5.67a1.7,1.7,0,0,1-.74.6,5,5,0,0,0-.8-.9s1.48,1.78.63,3-2.09.38-2.92-.49a15.48,15.48,0,0,0-4.21-3.48c-2.3-1.29-5.86-3-6-3.09.27-.7.43-1.34.58-1.86a45.66,45.66,0,0,0,7.93,2.5c3,.44,4.65.55,5.26,1.37A2.22,2.22,0,0,1,651.73,133.78Z",
    fill: "#60bcd8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M628.27,114.76c-1-.28-2.07-.5-2.07-.5a10.77,10.77,0,0,0-2.46-.31c-.74.08-2.15,2.14-1.63,4.28s1.13,3.61,3.21,3.87a3.81,3.81,0,0,0,4.15-3.82C629.54,115.88,629.22,115,628.27,114.76Z",
    fill: "#60bcd8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M638.57,117.88c0-2.06-2-4.13-2.72-4.25a10.32,10.32,0,0,0-2.4.18s-1.06.17-2,.4-1,1.07-.3,3.48,3.12,4.11,5.14,3.89S638.59,119.94,638.57,117.88Z",
    fill: "#4c5054"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M630.45,120.11s-1.21.3-1.17,3,.1,3.57.33,3.63.59-.9.88-1.39.33-.79.68-.79,1.3,1.43,1.57,1.72.2.32.43.28-.41-2.79-1-4.21S630.94,120.12,630.45,120.11Z",
    fill: "#4c5054"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M651.13,129.74c-1.3-1.05-4.09-.74-6.14-1.21-1.89-.43-6.4-2.14-7.09-2.41a1.41,1.41,0,0,1,.37-.57,10.33,10.33,0,0,0,2.07-2.65l2.36-1a22.43,22.43,0,0,1,5.59-1.62,2.18,2.18,0,0,0,1.93-2.36,2.25,2.25,0,0,0-1-1.76s0-.33-.14-.87a2.28,2.28,0,0,0-.87-1.42,1.73,1.73,0,0,0-2.37.06,13.66,13.66,0,0,1-2.45,2.53c-.53.38-1.94,1.16-2.71,1.57a17.65,17.65,0,0,1-.14-3.36,52.9,52.9,0,0,0,.37-6.6c-.07-2.48-.39-4.87-3.68-7s-6.44-3.49-10.81-3.23l-.33,0c-1.87,0-4.83.37-6.56,2-2.67,2.58-3,4.63-2.48,7.32s1.92,7.16,2.22,8.52a21.28,21.28,0,0,1,.34,2.16c-.9-.47-2.47-1.31-3.09-1.73a15.5,15.5,0,0,1-2.55-2.39,1.69,1.69,0,0,0-2.4-.18,1.74,1.74,0,0,0-.5,1.49c0,.57.09.92.09.92a1.79,1.79,0,0,0-.54,1.87,3.25,3.25,0,0,0,2.58,2.6,20.1,20.1,0,0,1,5.45,1.44l2.73,1.12a8.3,8.3,0,0,0,2.65,2.63,5,5,0,0,1,1.2,1,47.92,47.92,0,0,1-6.36,2.82c-1.93.51-4.42.17-5.44,1.32a2.62,2.62,0,0,0-.36,3.1,2.51,2.51,0,0,0,1.2,1.54l.32.14a3,3,0,0,0,1.12,2.45c1.18.81,2.16,1,3.27-1.08a13.05,13.05,0,0,1,5-4.88c1.73-1,2.95-1.72,3.34-1.94a6.51,6.51,0,0,0,4.2,1.8h0a3.65,3.65,0,0,0,.41,0h0c1,0,3.39-.19,4.42-1.88.12-.19.21-.39.31-.58l3.83,1.83a18.54,18.54,0,0,1,6.19,4.52c1.63,1.9,2.85,1.8,3.83,1s.21-2.35.21-2.35,0-.06.26-.21a1.76,1.76,0,0,0,1.16-1.41A3,3,0,0,0,651.13,129.74Zm-10.35-11s2.52-1.32,3.11-1.73a8,8,0,0,0,2-2.18,1.35,1.35,0,0,1,2-.23,2.58,2.58,0,0,1,.59,1.45,3.72,3.72,0,0,1-.39,1.32,2,2,0,0,0,.49-.83,1.4,1.4,0,0,1,.82,1.43c-.05.71-.22,1.19-2.39,1.55a21.41,21.41,0,0,0-5.16,1.8l-1.23.53,0-.35a4.86,4.86,0,0,0,.11-1.19,5.91,5.91,0,0,0,0-.72C640.8,118.84,640.78,118.74,640.78,118.74Zm-21.52,2.61a29.25,29.25,0,0,0-5.65-1.77c-2.28-.46-2.18-.83-2.43-1.61-.34-1.08.44-1.55.48-1.46a3.71,3.71,0,0,0,.72.91,5.67,5.67,0,0,1-.75-1.44,2.35,2.35,0,0,1,.22-1.54c.17-.43.89-1,1.66-.08a12.83,12.83,0,0,0,2.63,2.4c.66.43,3.23,1.75,3.56,1.92a3.31,3.31,0,0,0,0,.33c0,.14.07.33.12.53v0a16.79,16.79,0,0,0,.76,2.36Zm2.23,11.28a10.91,10.91,0,0,0-3.27,3.77c-.6.94-1.62,1.84-2.78.62s-.13-3.18-.17-3.16a3.65,3.65,0,0,0-.55,1,2.33,2.33,0,0,1-.9-.63,2.54,2.54,0,0,1-.34-2.57c.39-.9,2-1,4.89-1.54s7-3.16,7-3.16.24.5.47.94.85,1.46.85,1.46S623.5,131.22,621.49,132.63Zm14.16-5.15-.07.1c-.11,0-.2,0-.14.23a1.62,1.62,0,0,1-.19,1.54c-.4.39-.63-.72-.63-.72l-.08,0s.29,1.13-.11,1.27-.51-1-.51-1h-.14s.45,1.33-.15,1.53-.62-1.34-.62-1.34h-.27s.55,1.63-.33,1.69-.78-1.58-.78-1.58h-.35s.55,1.62-.37,1.65-.78-1.68-.78-1.68h-.34s.34,1.44-.22,1.46S629,129,629,129h-.13s0,.36,0,.72-.28.52-.46.26a3.67,3.67,0,0,1-.25-1.21h-.07s0,0,0,.3,0,.63-.39.57-.52-1.25-.58-1.68c0-.09,0-.16,0-.16s-.76-1.21-1.2-2.07-1.08-.83-2.25-1.44-2.68-1.36-3.35-5.69c0-.09,0-.14,0-.14l0-.19,0,0c-.06-.43-.12-.88-.16-1.38-.13-1.67.88-3.66.6-6.94s-1-3.74-1.08-3.53,0,4.12-.09,5.72a13.56,13.56,0,0,1-.25,2.45s-2.41-7.45-1.47-9.66,2.19-4.06,4.11-4.93a22.82,22.82,0,0,1,5.14-1.2,15.59,15.59,0,0,1,5.48,1.18c3.08,1.28,6.74,4.88,7.1,7a18.71,18.71,0,0,1,.14,5.36c-.14,2.28-.18,3-.18,3s-2.3-6.72-2.58-7.61-.8-1-.8,0a13.19,13.19,0,0,0,1.48,5.66c1.26,2.55,2.43,4.7,2.2,7.18S638,124,637,125A5.06,5.06,0,0,0,635.65,127.48Zm15.52,5.67a1.76,1.76,0,0,1-.74.6,4.65,4.65,0,0,0-.8-.9s1.48,1.78.63,3-2.09.37-2.93-.49a14.89,14.89,0,0,0-4.2-3.48c-2.3-1.29-5.86-3-6-3.09a15.8,15.8,0,0,0,.58-1.87,44.12,44.12,0,0,0,7.94,2.5c3,.45,4.65.55,5.25,1.38A2.22,2.22,0,0,1,651.17,133.15Z",
    fill: "#4c5054"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M627.7,114.12c-1-.27-2.06-.5-2.06-.5a10.93,10.93,0,0,0-2.46-.3c-.74.08-2.16,2.13-1.63,4.27s1.12,3.61,3.21,3.88a3.81,3.81,0,0,0,4.15-3.82C629,115.25,628.66,114.39,627.7,114.12Z",
    fill: "#4c5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickjacking);
export default __webpack_public_path__ + "static/media/clickjacking.8e4547a9282216a344a5754fc928876f.svg";
export { ForwardRef as ReactComponent };